import React from 'react';
import Hero from '../components/Hero';
import BookSummary from '../components/BookSummary';
import CoreThemes from '../components/CoreThemes';
import BookDetails from '../components/BookDetails';
import Excerpt from '../components/Excerpt';
import CallToAction from '../components/CallToAction';

const HomePage = () => (
  <main>
    <div id="home"><Hero /></div>
    <div id="the-book">
      <BookSummary />
      <CoreThemes />
      <BookDetails />
      <Excerpt />
    </div>
    <div id="get-copy"><CallToAction /></div>
  </main>
);

export default HomePage;